import {createSelector} from 'reselect';
import {DbMetaState} from '../redux/reducers/db';

export const getDbMetaObj = (state: Readonly<{dbMeta: DbMetaState}>) => state.dbMeta;
export const getCurUser = createSelector([getDbMetaObj], dbMeta => dbMeta.curUser);
export const getCurUserEmail = createSelector([getCurUser], curUser => curUser!.email);
export const getTodaysDate = (state: {dbMeta: DbMetaState}) => state.dbMeta.todaysDateUtc;
export const getUserGroupMemberships = (state: Readonly<{dbMeta: DbMetaState}>) => state.dbMeta.userGroupMemberships;
